//酒店管理
export default [{
  path: '/hotelFacilities',
  // component: () => import('../pages/hotelManage/hotelFacilities.vue'),
  component: () => import('../pages/hotelManage/hotelFacilities.vue'),
  name: 'hotelFacilities',
  title: "酒店参数",
  meta: {
    title: "酒店参数"
  }
},
  {
    path: '/hotel',
    component: () => import('../pages/hotelManage/hotel.vue'),
    name: 'hotel',
    title: "酒店管理",
    meta: {
      title: "酒店管理"
    }
  }, {
    path: '/addHotel',
    component: () => import('../pages/hotelManage/addHotel.vue'),
    name: 'AddHotel',
    title: "添加酒店",
    meta: {
      title: "添加酒店"
    }
  },
  {
    path: '/hotelShape',
    component: () => import('../pages/hotelManage/hotelShape.vue'),
    name: 'hotelShape',
    title: "房型管理",
    meta: {
      title: "房型管理"
    }
  },
  {
    path: '/addHotelShape',
    component: () => import('../pages/hotelManage/addhotelShape.vue'),
    name: 'AddhotelShape',
    title: "添加房型",
    meta: {
      title: "添加房型"
    }
  },
  {
    path: '/changeHotelShape',
    component: () => import('../pages/hotelManage/changeHotelShape.vue'),
    name: 'ChangehotelShape',
    title: "修改房型",
    meta: {
      title: "修改房型"
    }
  },
  {
    path: '/setHotelShapePrice',
    component: () => import('../pages/hotelManage/setHotelShapePrice.vue'),
    name: 'setHotelShapePrice',
    title: "修改房型",
    meta: {
      title: "修改房型"
    }
  },
  {
    path: '/sectorManagement',
    component: () => import('../pages/hotelManage/sectorManagement.vue'),
    name: 'SectorManagement',
    title: "板块管理",
    meta: {
      title: "板块管理"
    }
  },
  {
    path: '/hotelShapeInfo',
    component: () => import('../pages/hotelManage/hotelShapeInfo.vue'),
    name: 'HotelShapeInfo',
    title: "房型详情",
    meta: {
      title: "房型详情"
    }
  },
  {
    path: '/orderList',
    component: () => import('../pages/hotelManage/orderList.vue'),
    name: 'OrderList',
    title: "订单管理",
    meta: {
      title: "订单管理"
    }
  },
  {
    path: '/evaluationManage',
    component: () => import('../pages/hotelManage/evaluationManage.vue'),
    name: 'EvaluationManage',
    title: "评价管理",
    meta: {
      title: "评价管理"
    }
  },
  {
    path: '/checkIn',
    component: () => import('../pages/hotelManage/checkIn.vue'),
    name: 'CheckIn',
    title: "办理入住",
    meta: {
      title: "办理入住"
    }
  },
  {
    path: '/hotelInfo',
    component: () => import('../pages/hotelManage/hotelInfo.vue'),
    name: 'HotelInfo',
    title: "酒店详情",
    meta: {
      title: "酒店详情"
    }
  },
  {
    path: '/calendar',
    component: () => import('../pages/hotelManage/calendar.vue'),
    name: 'Calendar',
    title: "每日房间数量",
    meta: {
      title: "每日房间数量"
    }
  },
];
